import ExperienceInviteStatus from "./enums/ExperienceInviteStatus";
import FriendInviteStatus from "./enums/FriendInviteStatus";

enum ShareLinksType {
  EXPERIENCE_INVITE = 'ExperienceInvite',
  FRIEND_INVITE = 'FriendInvite'
}

type ExperienceInviteData = {
  status: ExperienceInviteStatus;
  inviterId: number;
  placeId: number;
  instanceId: string;
};

type FriendInviteData = {
  status: FriendInviteStatus;
  senderUserId: number;
  friendingToken: string;
}

export {
  ExperienceInviteData,
  FriendInviteData,
  ShareLinksType
};
